import React from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import { ThemeProvider } from "@airbus/components-react";
import { FeatureToggleProvider } from 'react-feature-toggles';
import { store } from "./store/store";
import "typeface-roboto";

import { getFeatureToggleList } from './config/feature.toggles';
import getConfig from './config';
import "./index.scss";

import AuthenticatedApp from "./containers/AuthenticatedApp/AuthenticatedApp";
import PostHogProviderWrapper from "./components/PostHogProviderWrapper/PostHogProviderWrapper";


const featureToggleList = getFeatureToggleList();
const config = getConfig()
const root = ReactDOM.createRoot(
  document.getElementById('root'),
);
root.
render(
  <React.StrictMode>
    <PostHogProviderWrapper isLocal={config.Local}>
      <ThemeProvider brand="skywise">
        <FeatureToggleProvider featureToggleList={featureToggleList}>
          <Provider store={store}>
            <BrowserRouter>
              <AuthenticatedApp />
            </BrowserRouter>
          </Provider>
        </FeatureToggleProvider>
      </ThemeProvider>
  </PostHogProviderWrapper>
</React.StrictMode >,
);
